import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 首页数据展示
	**/
	homeData() {
		return request({
	    url: baseUrl + '/dasboard/index',
	    method: 'GET'
	  })
	},

	/**
	 * 新首页数据展示
	**/
	newHomeData() {
		return request({
	    url: baseUrl + '/dasboard/newVersion',
	    method: 'GET'
	  })
	}
}